export default __webpack_public_path__ + "static/media/sentinel.66fbe1a1.jpg";